<template>
  <main-section
    :header="$t('LOCALIZATION')"
    :isEditMode="true"
    :hasTabsInFooter="true"
    :contentHandlesScroll="true"
    :onUpdate="onUpdate"
  >
    <div slot="fieldset" style="height: 100%;" ref="droptarget">
      <data-table
        id="i18n-table"
        :initialRows="rowsFromRegistry"
        :initialHeader="headerFromRegistry"
        :tableUpdatedHandler="tableUpdated"
        :styler="styler"
        :loading="loading"
      />
    </div>

    <router-link
      slot="left-bottom-menu"
      class="item"
      :to="{ name: 'i18n-for', params: { target: 'cuesta' } }"
      :active-class="'active'"
    >
      {{ $t('I18N_CUESTA') }}
    </router-link>
    <router-link
      slot="left-bottom-menu"
      class="item"
      :to="{ name: 'i18n-for', params: { target: 'manatee-strings' } }"
      :active-class="'active'"
    >
      {{ $t('I18N_MANATEE_STRINGS') }}
    </router-link>
    <router-link
      slot="left-bottom-menu"
      class="item"
      :to="{ name: 'i18n-for', params: { target: 'manatee-resources' } }"
      :active-class="'active'"
    >
      {{ $t('I18N_MANATEE_RESOURCES') }}
    </router-link>

    <template slot="rightBottomMenuSlot1">
      <div class="ui compact icon buttons" style="margin-right: 5px;">
        <button type="button" class="ui green button" @click="downloadCSV()">
          <i class="download icon"></i>
        </button>
        <button type="button" class="ui green button" @click="uploadCSV()">
          <i class="upload icon"></i>
        </button>
      </div>
      <a ref="downloadLink" href="#" style="display: none;"></a>
      <input ref="uploadButton" type="file" accept=".csv" style="display: none;" />
    </template>
  </main-section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

#mainSection {
  padding-left: 10px;
  padding-right: 20px;
}

#i18n-wrapper {
  height: 100%;
}

#i18n-table {
  height: 100%;
}
</style>

<script>
// @flow
import Vue from 'vue'
import papa from 'papaparse'
import DataTable from './DataTable'
import { Locale, Toast, File } from 'services'
import { MainSection } from 'ui'

export default {
  name: 'localization',
  components: { DataTable, MainSection },
  props: ['target'],

  data() {
    return {
      rowsFromRegistry: [],
      headerFromRegistry: [],
      updatedHeader: [],
      updatedRows: [],
      originalDescriptive: {},
      loading: null // loading promise
    }
  },

  methods: {
    tableUpdated(h, r) {
      this.updatedHeader = h
      this.updatedRows = r
    },

    uploadCSV() {
      this.$refs.uploadButton.click()
    },

    downloadCSV() {
      File.downloadFile(
        this.generateCSV(),
        this.target + '-i18n.csv',
        'text/csv',
        this.$refs.downloadLink
      )
    },

    generateCSV() {
      const data = _.map(_.filter(this.updatedRows, row => !row.deleted), row =>
        _.map(row, d => d.v)
      )
      data.unshift(_.map(this.updatedHeader, h => h.v))
      return papa.unparse(data, {
        header: true,
        delimiter: ',',
        quotes: true
      })
    },

    saveCuesta(locales) {
      return Promise.all(_.map(locales, l => Locale.addLocalesForLang(l.name, l))).then(() => {
        Locale.setCachedLocales(locales)
      })
    },

    saveManatee(type, locales) {
      // prepend manatee- to names
      _.each(locales, l => {
        l.name = `manatee-${l.name}`
        l.item.name = `manatee-${l.item.name}`

        const orgDescForLang = this.originalDescriptive[l.name]

        // we need to merge with the original descriptive
        l.item.descriptive = {
          strings:
            type === 'strings'
              ? l.item.descriptive
              : (orgDescForLang && orgDescForLang.strings) || {},
          resources:
            type === 'resources'
              ? l.item.descriptive
              : (orgDescForLang && orgDescForLang.resources) || {}
        }
      })

      return Promise.all(_.map(locales, l => Locale.addLocalesForLang(l.name, l)))
    },

    onUpdate() {
      // Produce proper output
      const lookup = _.reduce(
        this.updatedHeader,
        (memo, h, hIdx) => {
          // First entry is key, we skip that
          if (hIdx === 0) return memo
          memo[h.v] = _.reduce(
            this.updatedRows,
            (rmemo, r) => {
              // 1st entry is key,
              // hIdx entry is entry for current lang
              rmemo[r[0].v] = r[hIdx].v
              return rmemo
            },
            {}
          )
          return memo
        },
        {}
      )

      const locales = _.map(_.filter(this.updatedHeader, h => h.v !== 'key'), h => {
        return {
          id: h.id,
          name: h.v,
          typename: 'locale',
          item: { descriptive: lookup[h.v], name: h.v }
        }
      })

      switch (this.target) {
        case 'cuesta':
          return this.saveCuesta(locales)
        case 'manatee-strings':
          return this.saveManatee('strings', locales)
        case 'manatee-resources':
          return this.saveManatee('resources', locales)
      }
    },
    styler(c) {
      if (!c.v) {
        return {
          'background-color': '#f9df59 !important'
        }
      }
    },
    dropFunction(e) {
      if (e.dataTransfer.files.length === 1 && e.dataTransfer.files[0].type === 'text/csv') {
        const file = e.dataTransfer.files[0]
        this.processFile(file)
      }
    },
    processFile(file) {
      if (file.size > 2000000) {
        Toast.error(this.$i18n.t('ERR_FILE_TOO_LARGE', { max: '2MB' }))
        return
      }
      let r = new FileReader()
      r.onload = evt => {
        const csv = papa.parse(evt.target.result).data

        // do some checks on structure
        if (csv.length > 0) {
          const header = _.map(_.head(csv), h => {
            return { v: h }
          })
          if (header.length == 0 || header[0].v !== 'key') {
            Toast.error(this.$i18n.t('ERR_NO_KEY_IN_HEADER'))
            return
          }
          this.headerFromRegistry = header
        }

        this.rowsFromRegistry = _.map(_.tail(csv), row => {
          return _.map(row, d => {
            return { v: d }
          })
        })
        this.updatedRows = this.rowsFromRegistry
        this.updatedHeader = this.headerFromRegistry
        return this.updatedRows
      }
      r.readAsText(file)
    },

    extractFromRegistry(locales, extractContent, extractCulture) {
      if (!extractCulture) extractCulture = c => c
      if (!extractContent) extractContent = l => l.descriptive

      // build header from locale names (prepend with key)
      this.headerFromRegistry = this.updatedHeader = [
        { v: 'key', fixed: true, disabled: true },
        ..._.map(locales, l => ({ v: extractCulture(l.name), id: l.id }))
      ]

      // we save the original descriptive to be able to merge it back into the
      // manatee i18n when saving since that consists of both a strings and resources
      this.originalDescriptive = _.reduce(
        locales,
        (memo, l) => {
          memo[l.name] = l.descriptive
          return memo
        },
        {}
      )

      // construct a lookup to go fast from lang, key to value
      const lookup = _.reduce(
        locales,
        (memo, l) => {
          memo[extractCulture(l.name)] = extractContent(l) || {}
          return memo
        },
        {}
      )

      // map all keys
      const allKeys = _.uniq(_.flatMap(lookup, (strings, lang) => _.keys(strings)))

      // using the lookup
      this.rowsFromRegistry = this.updatedRows = _.map(allKeys, k => [
        { v: k, disabled: true },
        ..._.map(_.tail(this.headerFromRegistry), h => ({ v: lookup[h.v][k] }))
      ])
    },

    loadManateeStrings() {
      return Locale.getManateeLocales().then(({ locales }) => {
        this.extractFromRegistry(
          locales,
          l => l.descriptive.strings,
          c => c.replace('manatee-', '')
        )
      })
    },
    loadManateeResources() {
      return Locale.getManateeLocales().then(({ locales }) => {
        this.extractFromRegistry(
          locales,
          l => l.descriptive.resources,
          c => c.replace('manatee-', '')
        )
      })
    },
    loadCuesta() {
      return Locale.getLocales().then(({ locales }) => this.extractFromRegistry(locales))
    },

    load(newTarget) {
      switch (this.target || newTarget) {
        case 'cuesta':
          return this.loadCuesta()
        case 'manatee-strings':
          return this.loadManateeStrings()
        case 'manatee-resources':
          return this.loadManateeResources()
      }
    }
  },

  watch: {
    target(newTarget, oldTarget) {
      if (newTarget === oldTarget) return
      this.loading = this.load(newTarget)
    }
  },

  mounted() {
    // load data
    this.loading = this.load()

    // Allow drops on table
    if (this.$refs.droptarget)
      File.addDropFileFunctionalityToDroptarget(this.$refs.droptarget, this.dropFunction)

    // Listen for uploads from button
    this.$refs.uploadButton.addEventListener('change', e => {
      this.processFile(e.target.files[0])
    })
  }
}
</script>
